import { SxProps, Theme } from "@mui/material";
import colorsConstants from "src/app/constants/colors.constants";

const styles = {
  parent: {
    backgroundColor: colorsConstants.mainContentBackgroundColor,
    flex: 1,
    display: "flex",
    height: "100vh",
  },
  mainScreenContentContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    padding: "24px",
  },
  titleText: {
    color: colorsConstants.primaryText,
    fontSize: 24,
    textAlign: "center",
    flex: 1,
  },
  expandIcon: { color: colorsConstants.primaryText },
  newTimeslotContainer: {
    mb: 2,
    p: 2,
    borderRadius: 2,
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
  },
  titleContainer: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    width: "90%",
  },
  dateDetailsContainer: { display: "flex", justifyContent: "space-between" },
  newTimeslotButton: { mb: 2 },
  timeslotContainer: {
    display: "flex",
    flexDirection: "column",
    p: 1.5,
    mb: 1,
    borderRadius: 2,
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
  },
  timeslotMainInfoContainer: { display: "flex", alignItems: "center" },
  submitButton: {
    height: "56px",
  },
  newTimeslotDivider: { my: 2 },
  tagsContainer: { width: "100%" },
  tagsTitle: { mb: 1 },
  tagsStack: { mb: 2 },
  noTagsText: { opacity: 0.7 },
  newTagTitle: { mb: 1 },
  colorPicker: {
    "& input": {
      height: "42px",
      padding: 1,
    },
  },
  meetingDescriptionContainer: { mt: 2 },
  timeslotTag: {
    color: "#fff",
    marginLeft: "16px",
  },
  removeTimeslotButton: { color: "error.main", marginLeft: "auto" },
  modalCancelButton: { color: colorsConstants.error },
  selectorContainer: {
    width: "100%",
  },
  selectorPaper: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    boxShadow: "none",
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
